/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wd_GithubInputs */

const en_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ar_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const bn_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const de_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const es_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const fr_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pt_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const zh_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const tr_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ru_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pl_wd_github = /** @type {(inputs: Wd_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

/**
* | output |
* | --- |
* | "GitHub" |
*
* @param {Wd_GithubInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const wd_github = /** @type {((inputs?: Wd_GithubInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_GithubInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_wd_github(inputs)
	if (locale === "bn") return bn_wd_github(inputs)
	if (locale === "de") return de_wd_github(inputs)
	if (locale === "es") return es_wd_github(inputs)
	if (locale === "fr") return fr_wd_github(inputs)
	if (locale === "pt") return pt_wd_github(inputs)
	if (locale === "zh") return zh_wd_github(inputs)
	if (locale === "tr") return tr_wd_github(inputs)
	if (locale === "ru") return ru_wd_github(inputs)
	if (locale === "pl") return pl_wd_github(inputs)
	return en_wd_github(inputs)
});